import React from "react";
import styled from "styled-components";
import { COLORS } from "../../../assets/colors";

function Card({ title, content, descriptions, styles, icon }) {
  return (
    <CardWrapper style={styles}>
      <CardHeader>
        <Title style={{ color: styles?.color }}>{title}</Title>
        {icon && <IconWrapper>{icon}</IconWrapper>}
      </CardHeader>
      <Content style={{ color: styles?.color }}>{content}</Content>
      <Description style={{ color: styles?.color }}>
        {descriptions}
      </Description>
    </CardWrapper>
  );
}

export default Card;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background-color: ${COLORS.adminCardBg};
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: ${COLORS.adminShadow};
  width: 280px;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
`;

const Title = styled.p`
  margin: 0;
  color: ${COLORS.adminTextSecondary};
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.025em;
`;

const IconWrapper = styled.div`
  font-size: 1.5rem;
  opacity: 0.2;
`;

const Content = styled.h2`
  margin: 0;
  color: ${COLORS.adminTextPrimary};
  font-size: 1.875rem;
  font-weight: 700;
  line-height: 1.2;
`;

const Description = styled.p`
  margin: 0.5rem 0 0 0;
  color: ${COLORS.adminTextSecondary};
  font-size: 0.875rem;
  font-weight: 400;
  opacity: 0.8;
`;
